<div class="row mx-0">
    <div class="pr-1 pl-0 col-7 tool-tip-overflow" >
        <span class="sg-cell-value">{{params.value}}  </span>
    </div>
    <div class="col-5  pr-0 pl-0 sg-search-icon ">
        <span class="sg-foldericon float-right">
            <span class="material-icons edit_details_icon" *ngIf="params.data.hasPermission" (click)="editClickHandler(params.data)"> mode_edit</span>
            <span class="material-icons download_edit_icon" (click)="downloadClickHandler(params.data)" >file_download</span>
        </span>
    </div>
</div>



